module.exports = __webpack_public_path__ + "static/media/loc2_img9.378afbf7.jpg";